export enum DownloadBleedOptionTypes {
  INCHES = 'inches',
  CM = 'cm',
  MM = 'mm',
}
